import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserOnboardingService } from '@app/modules/user-onboarding/services';
import { ModalCustomComponent } from '@app/shared/modal-custom/modal-custom.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'mnf-modal-verify-pw',
  templateUrl: './modal-verify-pw.component.html',
  styleUrls: ['./modal-verify-pw.component.scss']
})
export class ModalVerifyPwComponent {
  
  passwordFlag = 'password';
  
  email: string;

  passForm: FormGroup;

  constructor(
    private modalRef: MatDialogRef<ModalCustomComponent>, 
    private onBoardServ: UserOnboardingService,
    private fb: FormBuilder,
    private toastServ: ToastrService
  ) { }

  ngOnInit(): void {
    this.passForm = this.fb.group({
      password: new FormControl('', Validators.compose([Validators.required, Validators.minLength(8)])),
    })
  }

  /** Función para verficar la contraseña del usuario */
  accept() {
    const { password } = this.passForm.value;

    this.onBoardServ.otpPassword(this.email, password).subscribe(res => {
      if(res){
        this.modalRef.close(true);
      } else {
        this.toastServ.warning('La contraseña ingresada es incorrecta');
      }
    })
  }

  /** Función para cerrar el modal */
  cancel() {
    this.modalRef.close(false);
  }

}
